import { uniq } from 'lodash-es';
import { isLocal } from 'utils/env';

export const LOCAL_STORAGE_KEYS = Object.freeze({
  SETTINGS: 'settings',
  DEVICES_DATA: 'devices-data',
} as const);

export const SESSION_STORAGE_KEYS = Object.freeze({
  // no session storage keys at the moment
} as const);

// Check for duplicate keys in local dev mode
if (isLocal) {
  const msg = 'Duplicate storage key found';
  const localStorageKeys = Object.values(LOCAL_STORAGE_KEYS);
  const sessionStorageKeys = Object.values(SESSION_STORAGE_KEYS);
  if (
    localStorageKeys.length !== uniq(localStorageKeys).length ||
    sessionStorageKeys.length !== uniq(sessionStorageKeys).length
  ) {
    throw new Error(msg);
  }
}
